import { render, staticRenderFns } from "./TheLngSettings.vue?vue&type=template&id=367c4322&"
import script from "./TheLngSettings.vue?vue&type=script&lang=js&"
export * from "./TheLngSettings.vue?vue&type=script&lang=js&"
import style0 from "./TheLngSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports